export default __webpack_public_path__ + "static/media/placeholder.2b508806.webp";